import { ReactComponent as HpgclIcon } from "../../icons/cerc-dashboard.svg";
export default function RuvnlHeading({ title }: { title: string }) {
  return (
    <div className="header flex items-center justify-between">
      <h1>{title}</h1>
      <div className="flex flex-row justify-center items-center space-x-2 ">
        <h1>Power Analytics</h1>
      </div>
    </div>
  );
}
export function RuvnlTitle() {
  return (
    <div className="flex flex-row justify-center items-center h-[58px] space-x-2 ">
      <div className="flex flex-row justify-center items-center space-x-4 ">
        <h1 className="text-[#6F6D7C] !text-[18px]">Power Analytics</h1>
      </div>
    </div>
  );
}

interface FooterProps {
  source: string;
  note: string;
}

export const GnaRuvnlFooter: React.FC<FooterProps> = ({ source, note }) => {
  return (
    <div className="gna-footer-container">
      <div className="flex justify-between">
        <p className="gna-footer-text">{source}</p>
        <p className="gna-footer-text col-span-1 text-center">
          Powered by <strong>GNA Energy</strong>
        </p>
        {/* <p className="gna-footer-text">Demo Version</p> */}
      </div>
      <p className="gna-footer-note">{note}</p>
      <p className="gna-footer-note">
        MW = Represents the average (MW) based on the selected time interval
        (Date or Month).
      </p>
    </div>
  );
};
